<template>
  <div ref="footer" class="footer-margin-top">
    <div
      class="tway-waves tway-waves-grey-2-down tway-waves-bottom tway-waves-reflect"
    ></div>
    <div class="partners">
      <v-container>
        <partners class="partners-desktop" />
        <partners-carousel class="partners-mobile" />
      </v-container>
    </div>
    <v-footer color="tway-morado" class="tway-footer">
      <v-container fluid>
        <v-row justify="space-between" :class="desktop ? 'px-16' : ''">
          <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
            <v-img
              alt="Tway alt logo"
              class="footer-logo shrink"
              contain
              :src="
                require('@/assets/images/logo/tway-logotipo-gris-byline-2.svg')
              "
              :min-width="mobile ? '110' : '200'"
              :width="mobile ? '110' : '200'"
            />
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="2"
            lg="2"
            xl="2"
            :style="mobile ? 'align-items: center;' : 'align-items: start;'"
            style="display: flex; flex-direction: column; justify-content: start;"
          >
            <strong class="white--text mb-3">Sobre Tway</strong>
            <router-link
              :to="{name: 'platform'}"
              class="white--text footer-nav-link"
            >
              Plataforma
            </router-link>
            <router-link
              :to="{name: 'plans'}"
              class="white--text footer-nav-link"
            >
              Planes
            </router-link>
            <router-link
              :to="{name: 'trends'}"
              class="white--text footer-nav-link"
            >
              Tendencias
            </router-link>
            <router-link
              :to="{name: 'help'}"
              class="white--text footer-nav-link"
            >
              ¿Qué es Tway?
            </router-link>
            <router-link
              :to="{name: 'team'}"
              class="white--text footer-nav-link"
            >
              Equipo
            </router-link>
            <a
              class="white--text footer-nav-link"
              href="http://static-dev.twaydigital.com/terms/landing/TerminosCondiciones.pdf"
              >Términos y condiciones</a
            >
            <a
              class="white--text footer-nav-link"
              href="http://static-dev.twaydigital.com/terms/landing/ProtocolizacionPromocion.pdf"
              >Bases promociones</a
            >
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="3"
            lg="3"
            xl="3"
            :style="mobile ? 'align-items: center;' : 'align-items: start;'"
            style="display: flex; flex-direction: column; justify-content: start;"
          >
            <strong class="white--text mb-3">Contacto</strong>
            <a href="mailto:contacto@tway.cl" class="white--text">
              contacto@tway.cl
            </a>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="3"
            lg="3"
            xl="3"
            :style="
              mobile
                ? 'align-items: center; margin-top: 5px;'
                : 'align-items: start;'
            "
            style="display: flex; flex-direction: column; align-items: start; justify-content: start;"
          >
            <strong class="white--text mb-3">Redes Sociales</strong>
            <v-row>
              <a href="https://www.linkedin.com/company/tway/" class="mr-4">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16 0C7.16333 0 0 7.16333 0 16C0 24.8367 7.16333 32 16 32C24.8367 32 32 24.8367 32 16C32 7.16333 24.8367 0 16 0ZM12.0833 22.6317H8.84333V12.205H12.0833V22.6317ZM10.4433 10.925C9.42 10.925 8.75833 10.2 8.75833 9.30333C8.75833 8.38833 9.44 7.685 10.485 7.685C11.53 7.685 12.17 8.38833 12.19 9.30333C12.19 10.2 11.53 10.925 10.4433 10.925ZM23.9167 22.6317H20.6767V16.8533C20.6767 15.5083 20.2067 14.595 19.035 14.595C18.14 14.595 17.6083 15.2133 17.3733 15.8083C17.2867 16.02 17.265 16.32 17.265 16.6183V22.63H14.0233V15.53C14.0233 14.2283 13.9817 13.14 13.9383 12.2033H16.7533L16.9017 13.6517H16.9667C17.3933 12.9717 18.4383 11.9683 20.1867 11.9683C22.3183 11.9683 23.9167 13.3967 23.9167 16.4667V22.6317Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a href="https://www.instagram.com/tway_digital/" class="mr-4">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.0625 16C19.0625 17.6914 17.6914 19.0625 16 19.0625C14.3086 19.0625 12.9375 17.6914 12.9375 16C12.9375 14.3086 14.3086 12.9375 16 12.9375C17.6914 12.9375 19.0625 14.3086 19.0625 16Z"
                    fill="white"
                  />
                  <path
                    d="M23.1616 10.5815C23.0144 10.1826 22.7795 9.82153 22.4744 9.52515C22.178 9.21997 21.8171 8.98511 21.418 8.83789C21.0942 8.71216 20.6079 8.5625 19.7122 8.52173C18.7432 8.47754 18.4526 8.46802 15.9995 8.46802C13.5461 8.46802 13.2556 8.47729 12.2869 8.52148C11.3911 8.5625 10.9045 8.71216 10.5811 8.83789C10.1819 8.98511 9.8208 9.21997 9.52466 9.52515C9.21948 9.82153 8.98462 10.1824 8.83716 10.5815C8.71143 10.9053 8.56177 11.3918 8.521 12.2876C8.47681 13.2563 8.46729 13.5469 8.46729 16.0002C8.46729 18.4534 8.47681 18.7439 8.521 19.7129C8.56177 20.6086 8.71143 21.095 8.83716 21.4187C8.98462 21.8179 9.21924 22.1787 9.52441 22.4751C9.8208 22.7803 10.1816 23.0151 10.5808 23.1624C10.9045 23.2883 11.3911 23.438 12.2869 23.4788C13.2556 23.5229 13.5459 23.5322 15.9993 23.5322C18.4529 23.5322 18.7434 23.5229 19.7119 23.4788C20.6077 23.438 21.0942 23.2883 21.418 23.1624C22.2192 22.8533 22.8525 22.22 23.1616 21.4187C23.2874 21.095 23.437 20.6086 23.478 19.7129C23.5222 18.7439 23.5315 18.4534 23.5315 16.0002C23.5315 13.5469 23.5222 13.2563 23.478 12.2876C23.4373 11.3918 23.2876 10.9053 23.1616 10.5815ZM15.9995 20.7178C13.3938 20.7178 11.2815 18.6057 11.2815 16C11.2815 13.3943 13.3938 11.2822 15.9995 11.2822C18.605 11.2822 20.7173 13.3943 20.7173 16C20.7173 18.6057 18.605 20.7178 15.9995 20.7178ZM20.9038 12.1982C20.2949 12.1982 19.8013 11.7046 19.8013 11.0957C19.8013 10.4868 20.2949 9.99316 20.9038 9.99316C21.5127 9.99316 22.0063 10.4868 22.0063 11.0957C22.0061 11.7046 21.5127 12.1982 20.9038 12.1982Z"
                    fill="white"
                  />
                  <path
                    d="M16 0C7.16479 0 0 7.16479 0 16C0 24.8352 7.16479 32 16 32C24.8352 32 32 24.8352 32 16C32 7.16479 24.8352 0 16 0ZM25.1321 19.7878C25.0876 20.7659 24.9321 21.4336 24.7051 22.0181C24.2278 23.2522 23.2522 24.2278 22.0181 24.7051C21.4338 24.9321 20.7659 25.0874 19.7881 25.1321C18.8083 25.1768 18.4954 25.1875 16.0002 25.1875C13.5049 25.1875 13.1921 25.1768 12.2122 25.1321C11.2344 25.0874 10.5664 24.9321 9.98218 24.7051C9.3689 24.4744 8.81372 24.1128 8.35474 23.6453C7.88745 23.1865 7.52588 22.6311 7.29517 22.0181C7.06812 21.4338 6.9126 20.7659 6.86816 19.7881C6.823 18.8081 6.8125 18.4951 6.8125 16C6.8125 13.5049 6.823 13.1919 6.86792 12.2122C6.91235 11.2341 7.06763 10.5664 7.29468 9.98193C7.52539 9.3689 7.88721 8.81348 8.35474 8.35474C8.81348 7.88721 9.3689 7.52563 9.98193 7.29492C10.5664 7.06787 11.2341 6.9126 12.2122 6.86792C13.1919 6.82324 13.5049 6.8125 16 6.8125C18.4951 6.8125 18.8081 6.82324 19.7878 6.86816C20.7659 6.9126 21.4336 7.06787 22.0181 7.29468C22.6311 7.52539 23.1865 7.88721 23.6455 8.35474C24.1128 8.81372 24.4746 9.3689 24.7051 9.98193C24.9324 10.5664 25.0876 11.2341 25.1323 12.2122C25.177 13.1919 25.1875 13.5049 25.1875 16C25.1875 18.4951 25.177 18.8081 25.1321 19.7878Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a href="https://www.facebook.com/TwayDigital " class="mr-4">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16 0C7.19999 0 0 7.21285 0 16.0964C0 24.1285 5.85599 30.7952 13.504 32V20.755H9.43999V16.0964H13.504V12.5462C13.504 8.51406 15.888 6.29719 19.552 6.29719C21.296 6.29719 23.12 6.60241 23.12 6.60241V10.5703H21.104C19.12 10.5703 18.496 11.8072 18.496 13.0763V16.0964H22.944L22.224 20.755H18.496V32C22.2663 31.4022 25.6995 29.4707 28.1758 26.5543C30.6522 23.6379 32.0085 19.9287 32 16.0964C32 7.21285 24.8 0 16 0Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a href="https://vimeo.com/twaydigital" class="mr-4">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16 32C13.8333 32 11.7604 31.5781 9.78125 30.7344C7.80208 29.8906 6.09896 28.7552 4.67188 27.3281C3.24479 25.901 2.10938 24.1979 1.26562 22.2188C0.421875 20.2396 0 18.1667 0 16C0 13.8333 0.421875 11.7604 1.26562 9.78125C2.10938 7.80208 3.24479 6.09896 4.67188 4.67188C6.09896 3.24479 7.80208 2.10938 9.78125 1.26562C11.7604 0.421875 13.8333 0 16 0C18.1667 0 20.2396 0.421875 22.2188 1.26562C24.1979 2.10938 25.901 3.24479 27.3281 4.67188C28.7552 6.09896 29.8906 7.80208 30.7344 9.78125C31.5781 11.7604 32 13.8333 32 16C32 18.1667 31.5781 20.2396 30.7344 22.2188C29.8906 24.1979 28.7552 25.901 27.3281 27.3281C25.901 28.7552 24.1979 29.8906 22.2188 30.7344C20.2396 31.5781 18.1667 32 16 32ZM20.5 8C19.5417 8 18.724 8.45312 18.0469 9.35938C17.3698 10.2656 17.0208 11.2917 17 12.4375C17.3333 12.1458 17.7083 12 18.125 12C18.5625 12 18.901 12.1094 19.1406 12.3281C19.3802 12.5469 19.5 12.9375 19.5 13.5C19.5 14.0208 19.3177 14.6823 18.9531 15.4844C18.5885 16.2865 18.1667 16.9896 17.6875 17.5938C17.2083 18.1979 16.8125 18.5 16.5 18.5C16.3542 18.5 16.2083 18.3333 16.0625 18C15.9167 17.6667 15.7708 17.1771 15.625 16.5312C15.4792 15.8854 15.3542 15.2708 15.25 14.6875C15.1458 14.1042 15.0156 13.3698 14.8594 12.4844C14.7031 11.599 14.5833 10.9375 14.5 10.5C14.1875 8.83333 13.5208 8 12.5 8C11 8 9.5 9.33333 8 12L8.5 13C8.72917 12.7292 9 12.4948 9.3125 12.2969C9.625 12.099 9.85417 12 10 12C10.1458 12 10.276 12.0469 10.3906 12.1406C10.5052 12.2344 10.5938 12.3698 10.6562 12.5469C10.7188 12.724 10.7708 12.8854 10.8125 13.0312C10.8542 13.1771 10.8906 13.3542 10.9219 13.5625C10.9531 13.7708 10.9792 13.9167 11 14C11.0833 14.375 11.2083 15.0625 11.375 16.0625C11.5417 17.0625 11.7135 17.9583 11.8906 18.75C12.0677 19.5417 12.3021 20.3698 12.5938 21.2344C12.8854 22.099 13.276 22.776 13.7656 23.2656C14.2552 23.7552 14.8333 24 15.5 24C16.3125 24 17.401 23.2865 18.7656 21.8594C20.1302 20.4323 21.3438 18.75 22.4062 16.8125C23.4688 14.875 24 13.2708 24 12C24 9.33333 22.8333 8 20.5 8Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a
                href="https://www.youtube.com/channel/UC15cSm5nW6i1QmBloq46cww "
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.6717 15.7217L14.9283 13.975C14.6017 13.8233 14.3333 13.9933 14.3333 14.355V17.645C14.3333 18.0067 14.6017 18.1767 14.9283 18.025L18.67 16.2783C18.9983 16.125 18.9983 15.875 18.6717 15.7217ZM16 0C7.16333 0 0 7.16333 0 16C0 24.8367 7.16333 32 16 32C24.8367 32 32 24.8367 32 16C32 7.16333 24.8367 0 16 0ZM16 22.5C7.81 22.5 7.66667 21.7617 7.66667 16C7.66667 10.2383 7.81 9.5 16 9.5C24.19 9.5 24.3333 10.2383 24.3333 16C24.3333 21.7617 24.19 22.5 16 22.5Z"
                    fill="white"
                  />
                </svg>
              </a>
            </v-row>
          </v-col>
        </v-row>
        <v-row justify="center">
          <a href="mailto:contacto@tway.cl" class="white--text">
            <span class="ml-2">&copy;2020 Tway</span>
          </a>
        </v-row>
        <v-row justify="center">
          <pre class="ml-2 version">{{ version }}</pre>
        </v-row>
      </v-container>
      <cookie-law
        buttonDeclineClass="white--text"
        v-on:accept="ThankYouMethod()"
        v-on:decline="ThankYouMethod()"
        theme="dark-lime"
        message="Este sitio web utiliza cookies para garantizar que obtengas la mejor experiencia en nuestro sitio web."
        buttonText="Aceptar Cookies"
        :buttonDecline="true"
        buttonDeclineText="Rechazar Cookies"
      ></cookie-law>
    </v-footer>
  </div>
</template>
<script>
  import Partners from "@/components/Partners";
  import PartnersCarousel from "@/components/PartnersCarousel";
  import CookieLaw from "vue-cookie-law";

  export default {
    name: "Footer",

    components: {
      Partners,
      PartnersCarousel,
      CookieLaw,
    },

    data: () => ({
      version: `v${process.env.VUE_APP_TWAY_VERSION}` || "",
      footerSticky: localStorage.getItem("footer_sticky"),
      bannerBool: localStorage.getItem("cookie:accepted") != null,
      startingModal: !localStorage.getItem("modal_sticky"),
    }),
    methods: {
      closeSticky() {
        localStorage.setItem("footer_sticky", true);
        this.footerSticky = "true";
      },
      closeStickyModal() {
        localStorage.setItem("modal_sticky", true);
        this.startingModal = false;
      },
      ThankYouMethod() {
        this.bannerBool = true;
      },
    },

    computed: {
      year() {
        return new Date().getFullYear();
      },
      mobile() {
        return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs;
      },
      ipad() {
        return this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.sm;
      },
      desktop() {
        return (
          this.$vuetify.breakpoint.md ||
          this.$vuetify.breakpoint.lg ||
          this.$vuetify.breakpoint.xl
        );
      },
    },
  };
</script>
<style>
  .footer-margin-top {
    margin-top: -10px;
  }

  .sticky {
    position: fixed;
    top: 90%;
    z-index: 1000;
    width: 100% !important;
  }

  #navbar-component {
    overflow: hidden;
    background-color: #333;
    height: 10%;
    background: linear-gradient(125.19deg, #119a24 0%, #7319d5 100%);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .sticky-mobile {
    position: fixed;
    top: 83%;
    z-index: 1000;
    width: 100% !important;
  }

  .sticky-ipad {
    position: fixed;
    top: 83%;
    z-index: 1000;
    width: 100% !important;
  }

  #navbar-component-ipad {
    padding-left: 5px;
    padding-right: 5px;
    overflow: hidden;
    background-color: #333;
    height: 17%;
    background: linear-gradient(125.19deg, #119a24 0%, #7319d5 100%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  #navbar-component-mobile {
    padding-left: 5px;
    padding-right: 5px;
    overflow: hidden;
    background-color: #333;
    height: 17%;
    background: linear-gradient(125.19deg, #119a24 0%, #7319d5 100%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  #navbar-component span {
    font-family: Roboto Condensed;
    font-style: normal;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    color: white;
  }

  .modal-sticky-p {
    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 25px;
    /* or 125% */

    text-align: center;

    /* Tway / Gris Oscuro */

    color: #333333;
  }

  #navbar-component-mobile span {
    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    color: white;
  }

  #navbar-component-ipad span {
    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    color: white;
  }

  .sticky-link {
    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    letter-spacing: 0.1em;
    text-transform: uppercase;

    /* Tway / Verde */

    color: #aeea00 !important;
  }

  .partners {
    background-color: #f1f1f1;
    padding-top: 50px;
    padding-bottom: 50px;
  }

  .partners-desktop {
    display: block;
  }

  .partners-mobile {
    display: none;
  }

  .tway-footer a {
    text-decoration: none;
  }

  .footer-contacto {
    margin-bottom: 0px;
  }

  .footer-nav {
    margin-left: 25px;
    margin-right: 25px;
  }

  .footer-nav-link {
    display: inline-block;
    margin-bottom: 0;
  }

  .footer-copyright {
    text-align: right;
  }

  .footer-linkedin {
    display: inline-block;
  }

  @media (max-width: 1120px) {
    .max-link {
      max-width: 100%;
    }
  }

  @media (min-width: 1121px) {
    .max-link {
      margin-right: 20px;
    }
  }

  @media (max-width: 960px) {
    .partners-desktop {
      display: none;
    }

    .partners-mobile {
      display: block;
    }

    .footer-logo {
      margin-left: auto;
      margin-right: auto;
    }

    .footer-contacto {
      text-align: center;
      margin-bottom: 20px;
    }

    .footer-nav {
      margin-left: 0px;
      margin-right: 0px;
    }

    .footer-nav-separator {
      display: none;
    }

    .footer-nav-link {
      text-align: center;
      display: block;
      margin-bottom: 10px;
    }

    .footer-copyright {
      text-align: center;
      margin-top: 10px;
    }

    .footer-linkedin {
      display: block;
      margin-top: 10px;
      margin-bottom: 20px;
    }
  }

  .version {
    color: white;
    font-size: 80%;
  }
</style>
